import
  React
from 'react';

export default ({
  size = '49'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 39 49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#5E2750"
      d="M0 7.64706C0 3.4237 3.42371 0 7.64706 0H29.2444C32.3033 3.44118 34.7941 6.11769 39 10.3235V41.2941C39 45.5175 35.5763 48.9412 31.3529 48.9412H7.64706C3.4237 48.9412 0 45.5175 0 41.2941V7.64706Z"
    />
    <path
      fill="#E60000"
      d="M32.9089 10.6175C30.4863 10.7145 28.535 8.6512 28.7671 6.23777L29.3494 0.183484L38.9862 10.374L32.9089 10.6175Z"
    />
    <path
      fill="#E60000"
      d="M11.146 25.3007V28.4706H9.66357V19.9393H12.9272C13.8804 19.9393 14.6362 20.1874 15.1948 20.6835C15.7573 21.1796 16.0386 21.8358 16.0386 22.6522C16.0386 23.4882 15.7632 24.1385 15.2124 24.6034C14.6655 25.0682 13.8979 25.3007 12.9097 25.3007H11.146ZM11.146 24.1112H12.9272C13.4546 24.1112 13.8569 23.9882 14.1343 23.7421C14.4116 23.4921 14.5503 23.1327 14.5503 22.6639C14.5503 22.203 14.4097 21.8358 14.1284 21.5624C13.8472 21.285 13.4604 21.1425 12.9683 21.1346H11.146V24.1112ZM17.3394 28.4706V19.9393H19.8589C20.6128 19.9393 21.2808 20.1073 21.8628 20.4432C22.4487 20.7792 22.9019 21.2557 23.2222 21.8729C23.5425 22.4901 23.7026 23.1971 23.7026 23.994V24.4218C23.7026 25.2303 23.5405 25.9413 23.2163 26.5546C22.896 27.1678 22.437 27.6405 21.8394 27.9725C21.2456 28.3046 20.564 28.4706 19.7944 28.4706H17.3394ZM18.8218 21.1346V27.287H19.7886C20.5659 27.287 21.1616 27.0448 21.5757 26.5604C21.9937 26.0721 22.2065 25.3729 22.2144 24.4628V23.9882C22.2144 23.0624 22.0132 22.3553 21.6108 21.8671C21.2085 21.3788 20.6245 21.1346 19.8589 21.1346H18.8218ZM30.0952 24.8553H26.6616V28.4706H25.1792V19.9393H30.5991V21.1346H26.6616V23.6718H30.0952V24.8553Z"
    />
  </svg>
);
